import { getStoredLocale, setStoredLocale } from './locale';
import { eventBus } from '../events/EventBus';
export const LANGUAGE_CHANGED_EVENT = 'language:changed';
class I18nService {
    constructor() {
        Object.defineProperty(this, "locale", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: getStoredLocale()
        });
        Object.defineProperty(this, "dictionary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "initialized", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "cache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
    }
    async initialize() {
        if (this.initialized)
            return;
        this.dictionary = await this.loadDictionary(this.locale);
        this.initialized = true;
    }
    getLocale() {
        return this.locale;
    }
    t(key, params) {
        if (!this.initialized) {
            console.warn('I18nService.t(): not initialized');
            return `[[${key}]]`;
        }
        const value = key.split('.').reduce((node, segment) => {
            if (node === null || typeof node !== 'object')
                return undefined;
            return node[segment];
        }, this.dictionary ?? undefined);
        if (typeof value !== 'string') {
            console.warn(`I18nService.t(): missing key "${key}" for locale "${this.locale}"`);
            return `[[${key}]]`;
        }
        if (!params)
            return value;
        return value.replace(/\{\{(\w+)\}\}/g, (match, name) => name in params ? String(params[name]) : match);
    }
    async changeLanguage(locale) {
        if (locale === this.locale)
            return;
        this.dictionary = await this.loadDictionary(locale);
        this.locale = locale;
        this.initialized = true;
        setStoredLocale(locale);
        eventBus.emit(LANGUAGE_CHANGED_EVENT, locale);
    }
    async loadDictionary(locale) {
        const cached = this.cache.get(locale);
        if (cached)
            return cached;
        const response = await fetch(`/locales/${locale}.json`);
        if (!response.ok) {
            throw new Error(`Failed to load locale "${locale}": ${response.status}`);
        }
        const dictionary = (await response.json());
        this.cache.set(locale, dictionary);
        return dictionary;
    }
}
export const i18nService = new I18nService();
